import React from "react";
import { Languages } from "../../../../components/languages";
import { Roles } from "../../../../auth/rolesPermissions";
import { PageTitle } from "../../../../components/guiElements";
import { getStockAPI } from "../../../../api/warehouseAPI";
import { warehouseUIProfiles } from "../../../../auth/warehouseProfiles";
import {  WarehouseFilters, WarehouseTable } from "../../Components/warehouseComponents";

//export default class WarehouseStock extends React.Component {
export default class StandardDealerStock extends React.Component {

    constructor(props) {
        super(props);
        this.getDataStock = this.getDataStock.bind(this);
        this.buildEntriesStock = this.buildEntriesStock.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterSearch = this.handleFilterSearch.bind(this);

        //this.profile = resolveProfile("standard-dealer");

        this.profile = props.profile;

        //this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.uc = props.userContext;
        this.uiProfile = warehouseUIProfiles[this.uc?.userRole] || warehouseUIProfiles.DEFAULT;
        this.le = Languages.Warehouse.Stock[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this._isMounted = false;

        this.configs = {
            filters: this.getFiltersConfig(),
        };

        this.header = this.getStockHeaders();
        const filters = this.createInitialFilters();
        this.appliedFilters = filters;

        this.state = {
            entries: [],
            filters: filters,
            products: [],
            totals: [],
            loading: true,
            advancedOpen: false,

            pageNumber: 1, //pagina corrente
            pageSize: 10, //numero di elementi per pagina
            sortField: "SKU", // campo per cui i dati vengono ordinati
            sortDirection: "asc", //asc/desc

            totalItems: 0, //numero totale di record trovati,
            totalPages: 0,//Numero torale di pagine

            profileReady: false,
            profileError: "",
        };

    }

    //#region Configuration Builders

    getStockHeaders() {

        const headers = [
            { label: this.le.list.captions[0], field: "SKU", className: "cell-center" },
            { label: this.le.list.captions[1], field: "description", className: "cell-description" },
            { label: this.le.list.captions[2], field: "avaibleQuantity", className: "cell-center" },
            { label: this.le.list.captions[3], field: "reservedQuantity", className: "cell-center" },
            { label: this.le.list.captions[4], field: "serialCode", className: "cell-center" },
            { label: this.le.list.captions[5], field: "SORD", className: "cell-center" },
            { label: this.le.list.captions[6], field: "BCNU", className: "cell-center" },
            { label: this.le.list.captions[7], field: "SCNU", className: "cell-center" },
            { label: this.le.list.captions[8], field: "ownerCode", className: "cell-center" },
            { label: this.le.list.captions[9], field: "CNUM", className: "cell-center", size: 2 },
        ]

        if (this.uiProfile.showDealerColumn) {
            headers.push(
                {
                    label: this.le.list.captions[10],
                    field: "dealerName",
                    className: "cell-center"
                },
                {
                    label: this.le.list.captions[11],
                    field: "dealerCode",
                    className: "cell-center"
                }
            );
        }

        return this.profile.customizeHeaders(headers);

    }

    getFiltersConfig() {
        const filters = {
            SKU: { type: "text", width: "20%" },
            description: { type: "text", width: "20%" },
            DELN: { type: "text", width: "20%" },
            SORD: { type: "text", width: "20%" },
            ...(this.uiProfile.showDealerColumn && {
                dealerCode: {
                    type: "text",
                    width: "20%"
                }
            }),
            SCNU: { type: "text", width: "20%" },
            SCNA: { type: "text", width: "20%" },
            CNUM: { type: "text", width: "20%" },
            serialCode: { type: "text", width: "20%" },

            QuantityFilter: {
                type: "inputGroup",
                width: "25%",
                options: [
                    { text: "...", value: "" },
                    { text: "=", value: "=" },
                    { text: ">", value: ">" },
                    { text: "<", value: "<" }
                ]
            },
        };

        filters.filterButton = { type: "button" };
        filters.clearButton = { type: "clearButton" };

        return this.profile.customizeFilters(filters);
    }

    createInitialFilters() {
        const filters = {};

        Object.keys(this.configs.filters).forEach(key => {
            if (key === "QuantityFilter") {
                filters[key] = {
                    Comparison: "",
                    Value: ""
                };
            } else {
                filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
            }
        });

        return filters;
    }

    //#endregion

    componentDidMount() {
        this._isMounted = true;

        this.setState({
            profileReady: true,
            profileError: ""
        }, () => {
            if (this._isMounted) {
                this.getDataStock(this.state.filters);
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    //#region Data functions

    //#region Get Stock Data

    parseSKUFilter(skuValue) {
        return (skuValue || "").split(";").map(sku => sku.trim()).filter(Boolean);
    }

    getDataStock = async (filters) => {
        if (this._isMounted) {
            this.setState({ loading: true })
        }

        const { pageNumber, pageSize, sortField, sortDirection } = this.state;

        try {
            const skuList = this.parseSKUFilter(filters.SKU);
            const dealerCode =
                this.uc.userRole === Roles.WAREHOUSEUSER
                    ? this.uc.dealerCode
                    : (filters.dealerCode || null);

            const getStockData = {
                Data: {
                    SKU: skuList,
                    dealerCode: dealerCode,
                    lot: filters.serialCode || null,
                    description: filters.description || "",
                    state: "BUONO",
                    SORD: filters.SORD || null,
                    DELN: filters.DELN || null,
                    SCNU: filters.SCNU || null,
                    SCNA: filters.SCNA || null,
                    CNUM: filters.CNUM || null,

                    warehouseLabelCode: null,
                    language: Languages.selectedLanguage.toUpperCase(),
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortField: sortField,
                    SortDirection: sortDirection
                }
            };

            const quantityComparison = filters.QuantityFilter?.Comparison;
            const quantityValue = filters.QuantityFilter?.Value;

            const hasQuantityComparison =
                quantityComparison !== null &&
                quantityComparison !== undefined &&
                quantityComparison !== "";

            const hasQuantityValue =
                quantityValue !== null &&
                quantityValue !== undefined &&
                quantityValue !== "";

            if (hasQuantityComparison && hasQuantityValue) {
                const parsedQuantityValue = parseInt(quantityValue, 10);

                getStockData.Data.QuantityFilter = {
                    Comparison: quantityComparison,
                    Value: Number.isNaN(parsedQuantityValue)
                        ? null
                        : parsedQuantityValue
                };
            } else {
                getStockData.Data.QuantityFilter = null;
            }

            getStockData.Data = this.profile.customizeStockRequest(getStockData.Data, filters);

            //this.props.loaderShow(0);
            const response = await getStockAPI(this.uc.jwtToken, getStockData);

            if (!this._isMounted) {
                return;
            }

            if (response.error == null) {
                //this.props.loaderHide();
                const stock = response?.result?.stock;
                const products = stock?.data ?? [];
                let entries = this.buildEntriesStock(products);

                let totals = [{ name: 'stock', val: response.result.stock.data.length }];

                if (this._isMounted) {
                    this.setState({
                        entries: entries,
                        products: response.result.stock.data,
                        totals: totals,
                        //loading: false,
                        pageNumber: stock?.pageNumber ?? pageNumber,
                        pageSize: stock?.pageSize ?? pageSize,
                        totalItems: stock?.totalItems ?? products.length,
                        totalPages: stock?.totalPages ?? 1
                    });
                }

            } else {
                //this.props.loaderHide();
                this.props.popupErrorMessage(response.error.message);
            }

        }
        catch (error) {
            if (this._isMounted) {
                this.props.popupErrorMessage(error.message || "Impossibile caricare lo stock.");
            }
        }
        finally {
            if (this._isMounted) {
                this.setState({ loading: false });
            }
        }
    }

    getStockEntryId = (product) => {
        if (product.id !== null && product.id !== undefined) {
            return String(product.id);
        }

        return [
            product.dealerCode || "",
            product.sku || "",
            product.lot || "",
            product.sord || "",
            product.sscc || "",
            product.ownerCode || ""
        ].join("|");
    };

    buildEntriesStock = (products) => {
        let entries = [];

        for (let i = 0; i < products.length; i++) {
            let product = products[i];

            let entry = {

                //#region standard-dealer
                id: this.getStockEntryId(product),
                SKU: product.sku,
                description: product.description,
                avaibleQuantity: product.availableQuantity?.toString() || "0",
                reservedQuantity: product.reservedQuantity?.toString() || "0",
                serialCode: product.lot ?? "",

                dealerName: product.dealerName ?? "",
                dealerCode: product.dealerCode ?? "",
                SORD: product.sord ?? "",
                SendLabel: product.sendLabel,
                ownerCode: product.ownerCode ?? "",
                BCNU: product.bcnu ?? "",
                SCNU: product.scnu ?? "",
                CNUM: product.cnum ?? "",
                SSCC: product.sscc ?? "",

                weight: product.weight ?? "0",
                volume: product.volume ?? "0",
                unitPrice: product.unitPrice ?? "0",
                originalPrice: product.originalPrice ?? "0",
                discount: product.discount ?? "0",
                voucher: product.voucher ?? "0",
                annotations: product.annotations ?? "",
                //#endregion

                //àregion NPO
                amount: product.amnt ?? "",
                //#endregion
            };

            entries.push(entry);
        }

        return entries;
    };

    // #endregion Get Stock Data

    handleClearFilters = () => {
        const filters = this.createInitialFilters();

        this.setState(
            {
                filters,
                pageNumber: 1
            },
            () => {
                this.getDataStock(filters);
            }
        );
    };

    handleFilterSearch = (ev) => {
        ev.preventDefault();

        this.setState(
            { pageNumber: 1 },
            () => this.getDataStock(this.state.filters)
        );
    }

    handleFilterChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "QuantityFilter.Comparison" || name === "QuantityFilter.Value") {
            const field = name.split(".")[1];

            return this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    QuantityFilter: {
                        ...prevState.filters.QuantityFilter,
                        [field]: value
                    }
                }
            }));
        }

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: type === "checkbox" ? checked : value
            }
        }));
    };

    handlePageChange = (pageNumber) => {
        this.setState(
            { pageNumber },
            () => this.getDataStock(this.state.filters)
        );
    }

    handlePageSizeChange = (pageSize) => {
        this.setState(
            {
                pageSize,
                pageNumber: 1
            },
            () => this.getDataStock(this.state.filters)
        );
    }

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            advancedOpen: !prevState.advancedOpen
        }));
    };

    //#endregion Data functions

    render() {

        if (!this.state.profileReady) {
            return (
                <div>
                    {this.state.profileError || "Caricamento configurazione warehouse..."}
                </div>
            );
        }

        return <div className="page-storaging">
            <PageTitle icon="../images/mainMenu/Giacenze.png" title={Languages.getSection('Main').menuLabels.stock} />
            <div className="page-content">

                <fieldset className="warehouse-loading-controls" disabled={this.state.loading}>
                    <WarehouseFilters
                        config={this.profile.stock.components.filters}
                        fields={this.configs.filters}
                        values={this.state.filters}
                        labels={this.le.filters.items}
                        onChange={this.handleFilterChange}
                        onSearch={this.handleFilterSearch}
                        onClear={this.handleClearFilters}
                        advancedOpen={this.state.advancedOpen}
                        onAdvancedToggle={this.toggleAdvancedFilters}
                    />
                </fieldset>

                <div className="readonly-table-safe-area">
                    <WarehouseTable
                        config={this.profile.stock.components.table}
                        loading={this.state.loading}
                        loadingMessage={this.le.loadingMessage}
                        headers={this.header}
                        items={this.state.entries}
                        rowKey="id"
                        serverSidePagination={true}
                        currentPage={this.state.pageNumber}
                        itemsPerPage={this.state.pageSize}
                        totalItems={this.state.totalItems}
                        totalPages={this.state.totalPages}
                        onPageChange={this.handlePageChange}
                        onItemsPerPageChange={this.handlePageSizeChange}
                    />
                </div>

            </div>
        </div>;
    }
}